<template>
  <div class="home">
    <img src="@/assets/logo higo-05-min.png" alt="higo logo" id="logoHigo">
    <main v-if="pop === false">
      <div class="lang">
        <img @click.prevent="lang = 'bahasa'" src="@/assets/bendera Indonesia-08-min.png" alt="Bahasa" :class="[lang !== 'bahasa' ? 'notSelected' : null]">
        <img @click.prevent="lang = 'eng'" src="@/assets/bendera USA-08-min.png" alt="English" :class="[lang !== 'eng' ? 'notSelected' : null]">
      </div>
      <div class="main-content">
        <div class="text" v-if="lang === 'eng'">
          <h1>Manage Your Privacy Choices</h1>
          <h2>You’re in control</h2>
          <h3>Your privacy is our utmost importance and HIGO wants to make sure that you are always in control of your privacy and choices. We hope that our HIGOspot Service (Free connectivity, information, or other content) has been useful for you, and HIGO is going to respect the decision that you are going to choose below.</h3>   
          <div class="input-container">
            <div class="plane-container">
        <div class="mover"></div>
        <svg xmlns="http://www.w3.org/2000/svg"
     width="100%" height="100%"
     viewBox="0 0 629 481">
  <path id="Unnamed"
        fill="none" stroke="#6CC7BD" stroke-dasharray="10,10" stroke-linecap="round" stroke-width="4"
        d="M 626.00,476.25
           C 626.00,476.25 445.91,507.79 279.59,349.77
             137.33,173.64 228.00,133.35 245.51,138.35
             253.64,135.85 280.11,159.59 260.83,189.57
             248.32,200.50 201.21,222.04 156.19,174.58
             111.17,127.11 117.01,125.23 98.88,99.62" />
  <image href="@/assets/pesawat kertas-06-min.png" alt="plane" id="plane"/>     
</svg>
      </div>
            <input style="display:block; text-align:center;" v-model="input" type="text" placeholder="Input Your Email or Phone Number">
          </div>
                    <p class="error" style="color: #E44027; margin: 0 auto;" v-if="noInput === true">*Input your email or phone number</p>
          <p class="error" style="color: #E44027; margin: 0 auto;" v-if="validationFail === true">*The email format or phone number that you enter is wrong <br/> Example: clara@gmail.com or 0812345678</p>
          <p>You can input your email or phone number to stop receiving promotional or digital contents from HIGO.</p>
          <div class="btn-delete" @click.prevent="switchOff">Delete</div>
        </div>
        <div class="text" v-if="lang === 'bahasa'">
          <h1>Kelola Informasi Rahasia Kamu</h1>
          <h2>Kamu yang pegang kendali</h2>
          <h3>Privasi kamu adalah hal terpenting bagi kami dan HIGO ingin memastikan bahwa kamu selalu bisa mengendalikan privasi yang kamu miliki dan juga menentukan pilihan. Kami berharap Layanan HIGOspot yang kami miliki (Konektivitas gratis, informasi, atau konten lainnya) bermanfaat bagi kamu, dan HIGO akan menghormati keputusan yang kamu ambil di bawah ini.</h3>        
          <div class="input-container">
            <div class="plane-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 629 481">
                <path id="Unnamed"
                      fill="none" stroke="#6CC7BD" stroke-dasharray="10,10" stroke-linecap="round" stroke-width="4"
                      d="M 626.00,476.25
                         C 626.00,476.25 445.91,507.79 279.59,349.77
                           137.33,173.64 228.00,133.35 245.51,138.35
                           253.64,135.85 280.11,159.59 260.83,189.57
                           248.32,200.50 201.21,222.04 156.19,174.58
                           111.17,127.11 117.01,125.23 98.88,99.62" />
                  <image href="@/assets/pesawat kertas-06-min.png" alt="plane" id="plane"/>     
                </svg> 
              </div>
              <input style="display:block; text-align:center;" v-model="input" type="text" placeholder="Masukkan Email atau Nomor HP">
          </div>
          <p class="error" style="color: #E44027; margin: 0 auto;" v-if="noInput === true">*Masukkan email atau nomor hp kamu</p>
          <p class="error" style="color: #E44027; margin: 0 auto;" v-if="validationFail === true">*Format email atau nomor HP yang kamu masukkan salah. <br/> Contoh: clara@gmail.com atau 0812345678</p>          
          <p>Masukkan email atau nomor HP kamu untuk berhenti menerima konten promosi atau konten digital lainnya dari HIGO.</p>
          <div class="btn-delete" @click.prevent="switchOff">Hapus</div>
        </div>
      </div>

      <div class="footer-logo">
        <img src="@/assets/logo higo-05-min.png" alt="logo higo" id="higo-logo">
      </div>
    </main>

    <div class="popup" v-if="pop === true">
      <div class="popup-msg" id="modal-template" v-if="lang === 'bahasa'">
        <transition name="fade">
         <div class="modal-mask">
          <div class="modal-wrapper">
        <div class="modal-container" v-if="agree === false">

          <div class="modal-body" v-if="!loading">
            <h1 style="font-size: 1.8rem;">Apakah kamu yakin ingin menghapus email atau nomor telepon?</h1>
          </div>
            <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#1A499F"/>  
          <div class="modal-footer" v-if="!loading">
              <button class="modal-btn-nope" @click.prevent="closeModal">
                Tidak
              </button>
              <button class="modal-btn-ok" @click.prevent="modalAgree">
                Hapus
              </button>
          </div>
        </div>
        <transition name="fade">
        <div class="modal-container-agree" v-if="agree === true">
          <div class="modal-body" style="display: flex; position: relative">
            <img style="width: 800px; margin: 0 auto;" src="@/assets/Pop Up-min.png" alt="" class="mail">
            <div style="position: absolute; display: flex; flex-direction: column; justify-content: space-between; align-items: center; width: 100%; height: 100%;">
              <h1 style="font-size: 1.8rem; color: #1A499F; margin-top: 6rem; width: 40rem; " class="mail-text">Kamu dengan aman sudah menghapus id HIGO dan tidak akan menerima konten promosi dan digital dalam waktu dekat.</h1>
              <button class="btn-done" @click.prevent="doneAgree">Terima Kasih</button>
            </div>
          </div>  
        </div>
        </transition>
      </div>
    </div>
  </transition>
      </div>
      <div class="popup-msg" id="modal-template" v-if="lang === 'eng'">
        <transition name="fade">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-if="agree === false">

          <div class="modal-body" v-if="!loading">
            <h1 style="font-size: 1.8rem;">Are you sure want to delete email or phone number?</h1>
          </div>
          <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#1A499F"/>
             <div class="modal-footer" v-if="!loading">
              <button class="modal-btn-nope" @click.prevent="closeModal">
                No
              </button>
              <button class="modal-btn-ok" @click.prevent="modalAgree">
                Delete
              </button>
          </div>
        </div>

        <transition name="fade">
        <div class="modal-container-agree" v-if="agree === true">

          <div class="modal-body" style="display: flex; position: relative">
            <img style="width: 800px; margin: 0 auto;" src="@/assets/Pop Up-min.png" alt="" class="mail">
            <div style="position: absolute; display: flex; flex-direction: column; justify-content: space-between; align-items: center; width: 100%; height: 100%;">
              <h1 style="font-size: 1.8rem; color: #1A499F; margin-top: 6rem; width: 40rem; "  class="mail-text">You have safely removed your HIGO id and will not receive promotional or digital contents for the near future.</h1>
              <button class="btn-done" @click.prevent="doneAgree">Thank You</button>
            </div>
          </div> 
        </div>
        </transition>
      </div>
    </div>
  </transition>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

const baseUrl = 'https://apim.higo.id/privacy-save-optout'
export default {
  name: 'home',
  components: { VueElementLoading },
  data: function () {
    return {
      lang: 'bahasa',
      input: null,
      pop: false,
      agree: false,
      noInput: false,
      validationFail: false,
      type: null,
      loading: false,
      errorShake: false
    }
  },
  watch: {
    'this.errorShake': {
      handler (val, olval) {
        if (val === true) {
          this.errorShake = false
        }
      }
    }
  },
  methods: {
    emailValidation (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    phoneValidation (phone) {
      const re = /^08[0-9]{9,}$/
      return re.test(String(phone))
    },
    switchOff () {
      // console.log('masuk')
      // this.errorShake = false
      if (this.input === null || this.input === '') {
        this.errorShake = !this.errorShake
        this.noInput = true
        this.validationFail = false
        return
      }

      if (this.emailValidation(this.input) || this.phoneValidation(this.input)) {
        if (this.emailValidation(this.input)) {
          this.type = 'email'
          this.pop = true
        } else  if (this.phoneValidation(this.input)) {
          this.type = 'phone'
          this.pop = true
        } else {
          this.pop = false
        }
      } else {
        this.errorShake = true
        this.noInput = false
        this.validationFail = true
      }
    },
    closeModal () {
      this.pop = false
      this.validationFail = false
      this.noInput = false
    },
      modalAgree () {
      this.loading = true
      const formData = new FormData()
      formData.append('value', this.input)
      if (this.type === 'email') {
        formData.append('type', 'email')
        axios({
          method: 'post',
          url: baseUrl,
          data: formData
        })
        .then(({data}) => {
          this.loading = false
          this.agree = true
          this.input = ''
          this.noInput = false
          this.validationFail = false
        })
      } else {
        formData.append('type', 'phone')
        axios({
          method: 'post',
          url: baseUrl,
          data: formData
        })
        .then(({data}) => {
          this.loading = false
          this.agree = true
          this.input = ''
          this.noInput = false
          this.validationFail = false
        })
      }
    },
    doneAgree () {
      this.agree = false
      this.pop = false
      window.location.href = 'http://www.higo.id'
    }
  }
}
</script>

<style scoped>
#logoHigo {
  position: absolute; 
  width: 10vh;
  right: 1rem;
  bottom: 1rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to  {
  opacity: 0;
}

.plane-container {
  position: absolute;
  width: 24rem;
  top: -16.5rem;
    left: -24rem;
}

#plane-track {
  width: 18rem;
}

#plane {
  motion-path: path("M 626.00,476.25 C 626.00,476.25 445.91,507.79 279.59,349.77 137.33,173.64 228.00,133.35 245.51,138.35 253.64,135.85 280.11,159.59 260.83,189.57 248.32,200.50 201.21,222.04 156.19,174.58 111.17,127.11 117.01,125.23 98.88,99.62");
  offset-path: path("M 626.00,476.25 C 626.00,476.25 445.91,507.79 279.59,349.77 137.33,173.64 228.00,133.35 245.51,138.35 253.64,135.85 280.11,159.59 260.83,189.57 248.32,200.50 201.21,222.04 156.19,174.58 111.17,127.11 117.01,125.23 98.88,99.62");
   motion-rotation: reverse;
   animation: move 3s 1;
   -webkit-animation: move 3s 1;
   animation-fill-mode: forwards; 
   -webkit-animation-fill-mode: forwards;  
}

image {
  overflow: auto !important;
}

svg:not(:root) {
    overflow: auto !important;
}

@-webkit-keyframes move {
  0% {
    opacity: 0;
      transform: translate(20px, -42px) rotate(39deg);

  }
  10%{
    opacity: 0.5;
      transform: translate(20px, -42px) rotate(39deg);

  }
  20% {
    opacity: 1;
      transform: translate(20px, -42px) rotate(39deg);

  }
  50% {
    opacity: 1;
      transform: translate(20px, -42px) rotate(39deg);

  }
  80% {
    transform: translate(20px, -42px) rotate(60deg);
    opacity: 1; 
  }
  90% {
    transform: translate(20px, -42px) rotate(60deg);
    opacity: 1;
  }
  99% {
    motion-offset: 100%;
    offset-distance: 100%;
    opacity: 1;
  }
  100% { 
    transform: translate(80px, 5px) rotate(100deg);
     motion-offset: 100%;
    offset-distance: 100%;
  }
}

@keyframes move {
  0% {
    opacity: 0;
      transform: translate(20px, -42px) rotate(39deg);

  }
  10%{
    opacity: 0.5;
      transform: translate(20px, -42px) rotate(39deg);

  }
  20% {
    opacity: 1;
      transform: translate(20px, -42px) rotate(39deg);

  }
  50% {
    opacity: 1;
      transform: translate(20px, -42px) rotate(39deg);

  }
  80% {
    transform: translate(20px, -42px) rotate(60deg);
    opacity: 1; 
  }
  90% {
    transform: translate(20px, -42px) rotate(60deg);
    opacity: 1;
  }
  99% {
    motion-offset: 100%;
    offset-distance: 100%;
    opacity: 1;
  }
  100% { 
    transform: translate(80px, 5px) rotate(100deg);
     motion-offset: 100%;
    offset-distance: 100%;
  }
}

@keyframes spin {
  100% {
    transform: translate(90px, 10px) rotate(120deg);
  }
}

#plane {
      width: 5rem;
    height: 64px;

  position: absolute;
  z-index: 999;
  transform: translate(20px, -42px) rotate(39deg);
  /* left: -66%;
    top: -31rem; */
  /* left: -54%;
  top: -22rem; */
  /* top: -5rem;
    left: -7rem; 
    */
    /* top: -6rem; */
    /* left: -2rem; */
}

.error-shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  /*backface-visibility: hidden;
  perspective: 1000px;  */
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

main {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #1A499F;
  color: white;
  font-family: 'Akzidenz Grotesk Black', sans-serif;
  background: url('~@/assets/Background-min.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.lang {
  padding: 10px 20px;
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: flex-end;
}

.lang img {
  width: 45px;
  height: 46px;
  margin: 0 10px;
  cursor: pointer;
  transition: .3s;
}

.lang .notSelected {
opacity: 0.5;
transition: .3s;
}

.main-content {
  width: 100%;
  height: 95%;
}

.text {
  padding-bottom: 5rem;
  width: 768px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.text h1 {
  font-size: 2rem;
}

.text h2 {
  font-size: 1.5rem;
  margin: 1.2rem 0;
}
.text h3 {
  font-size: 14px;
  width: 37rem;
  margin: 0 auto;
  line-height: 1.5;
}

.text p {
  font-size: 0.9rem;
  width: 35.5rem;
  margin: 1rem auto; 
  line-height: 1.5;
}

h1, h2, h3, p {
  text-align: center;
}

.text .input-container {
  margin: 2rem auto 1rem auto;
  width: 22rem;
  height: 3rem;
  position: relative;
}

.text input {
width: 22rem;
  height: 3rem;
  padding: 5px;
  border: none;
  border-radius: 50px;
  font-size: 1.3rem;
}

.btn-delete {
  margin: 0 auto 0 auto;
  width: 9rem;
  background-color: #E44027; 
  text-align: center;
  height: 2.8rem;
  border-radius: 50px;
  display: flex;
  font-size: 1.5rem;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: .3s;
}

.btn-delete:hover {
  background-color: #b3301d; 
}

.popup {
  width: 100%;
  height: 100vh;
  background-color: #1A499F;
}

.error {
  width: 28rem !important;
}

.btn-done {
  cursor: pointer;
  width: 14rem;
  border: none;
  border-radius: 50px;
  height: 4rem;
  font-size: 1.2rem;
  margin-bottom: 2.5rem;
  background-color: #6DCCDC;
  color: white;
  font-size: 1.8rem;
  transition: .3s;
}

.btn-done:hover {
  background-color: #59a6b3;
}

::-webkit-input-placeholder {
   text-align: center;
   font-size: 1.2rem;
}

:-moz-placeholder { /* Firefox 18- */
   text-align: center;  
}

::-moz-placeholder {  /* Firefox 19+ */
   text-align: center;  
}

:-ms-input-placeholder {  
   text-align: center; 
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  color:#1A499F;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-body h1 {
  font-family: 'Akzidenz Grotesk Black', sans-serif;
}

.modal-default-button {
  float: right;
}

.modal-btn-nope, .modal-btn-ok, .btn-done {
    font-family: 'Akzidenz Grotesk Black', sans-serif;
}

.modal-footer {
  display: flex;
  padding: 20px;
  justify-content: space-around;
}

.modal-footer button {
  width: 5.5rem;
  height: 3rem;
  font-size: 1.4rem;
  border: none;
  border-radius: 50px;
  color: white;
  transition: .3s;
  cursor: pointer;
}

.modal-btn-nope {
  background-color:#1A499F;
}

.modal-btn-ok {
  background-color:#E44027;
}

.modal-btn-nope:hover {
  background: #10234F;
}

.modal-btn-ok:hover {
  background: #b3301d;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 575px) {   
  .lang {
    justify-content: center;
  }

  .text {
    width: 100%;
    padding: 5px 10px 3rem 10px;
    justify-content: flex-start;
  }
  
  .text h1 {
    font-size: 1.2rem;
    margin-top: 10px;
  }

  .text h2 {
    font-size: 1rem;
    margin: 1rem 0;
  }

  .text h3 {
    font-size: 0.8rem;
    width: 100%;
    text-align: justify;
    padding: 0 10px;
  }

  .input-container {
    width: 100% !important;
    height: 2rem !important;
    margin: 10px auto 10px auto;
  }

  .input-container input {
    width: 85%;
    height: 2rem;
    font-size: 16px !important;
    margin: 0 auto;
  }

  .input-container input::placeholder{
    font-size: 16px;
  }

  .text p {
    width: 100%;
    font-size: 0.8rem
  }

  .error {
    width: 100% !important;
    font-size: 10px !important;
  }
  .modal-container {
    width: 90%;
  }

  .modal-body {
    width: 90%;
    margin: 0 auto;
  }

  .modal-body h1 {
    font-size: 1.2rem !important;
  }

  .mail {
    width: 95% !important;
  }

  h1.mail-text {
    font-size: 0.8rem !important;
    margin-top: 2rem !important;
    margin-bottom: 5rem !important;
    width: 80% !important;
  }

  .btn-done {
    font-size: 1.5rem;
  }
}
</style>
